export default __webpack_public_path__ + "static/media/abebooks.21ae4483.png";